import { ThemeBlueprint } from '@backstage/plugin-app-react';
import { UnifiedThemeProvider } from '@backstage/theme';
import LightIcon from '@material-ui/icons/WbSunny';
import { DarkMode } from '@mui/icons-material';
import { clearisticTheme } from './clearisticTheme';
import { clearisticThemeDark } from './clearisticThemeDark';

/**
 * The new frontend system ships its own `light` and `dark` themes and adds
 * these alongside them, so `theme:app/light` and `theme:app/dark` are disabled
 * in `app-config.yaml` to keep the theme picker to the two Clearistic themes.
 */
export const clearisticLightTheme = ThemeBlueprint.make({
  name: 'clearistic2',
  params: {
    theme: {
      id: 'clearistic2',
      title: 'Clearistic 2',
      variant: 'light',
      icon: <LightIcon />,
      Provider: ({ children }) => (
        <UnifiedThemeProvider theme={clearisticTheme} themeName="clearistic">
          {children}
        </UnifiedThemeProvider>
      ),
    },
  },
});

export const clearisticDarkTheme = ThemeBlueprint.make({
  name: 'clearistic2-dark',
  params: {
    theme: {
      id: 'clearistic2Dark',
      title: 'Clearistic 2',
      variant: 'dark',
      icon: <DarkMode />,
      Provider: ({ children }) => (
        <UnifiedThemeProvider theme={clearisticThemeDark} themeName="clearistic">
          {children}
        </UnifiedThemeProvider>
      ),
    },
  },
});
